"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var creds = {
    admin: {
        user: "admin",
        email: "mierome16@gmail.com",
        password: "getdocsadmin1",
        userId: 64298,
        ClientId: null,
        address: "6444 Birdcall St",
        state: "NV"
    },
    client: {
        user: "client",
        email: "ierome.malina@gmail.com",
        password: "GreenSeed11",
        userId: 64304,
        item: {
            ClientId: 64304,
            ClientTypeId: 1,
            address: "9112 Little Horse Ave",
            state: "NV",
            EffectiveDate: new Date().getDate(),
            ManagerLevelPermissions: null,
            DynamicDocumentsDLL: null,
            MonthlyReminderEmailAddress: "bgreene@getdocsnow.com",
            IsRegistered: 1,
            IsActive: 1,
            UseDynamicPricing: 0,
            AllowReleaseDocsBeforePayment: 0,
            Statement: null,
            TollFree: null,
            SectionTextHtmlColorCode: "ffffff",
            SectionTextHtmlBackgroundColorCode: "832092",
            Website: null,
            IsUpdateAllowed: 1,
            GdnUpdatePrice: 2,
            ClientUpdatePrice: 1,
            FreeUpdateDayDuration: 4,
            PaidUpdateDayDuration: 180,
            TimezoneId: 7,
            IsTest: 1,
            IsUsingCalendarDays: 0,
            IsEscrowDisclaimerCustom: 1,
            CustomEscrowDisclaimerText: "ATTN: Prior to ordering a demand statement, it is advised that you review the Resale ;;;;\n                                    Certificate for this property to determine if the file is active with a collection agency                                ;;;;\nPlease note: Failure to verify this status prior to ordering a demand statement online will not be considered;;;;\n                               ",
            IsPrintCompanyName: 1,
            IsPrintCompanyAddress: 1,
            StandardProcessing: 10,
            TaxIdNumber: "1234-56789",
            GdnAdminNotes: null,
            UseFolderManager: 1,
            hasDynamicQuestionnaire: 1,
            WhoToCall: null
        }
    },
    buyer: {
        user: "buyer",
        email: "alyssazuluaga23@icloud.com",
        password: "Password1!",
        userId: 64302,
        ClientId: null,
        address: "2113 Cactus Desert Ct",
        state: "NV"
    }
};
exports.default = creds;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlZHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvZGF0YS9jcmVkcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVlBLElBQU0sS0FBSyxHQUFnQjtJQUN6QixLQUFLLEVBQUU7UUFDTCxJQUFJLEVBQUUsT0FBTztRQUNiLEtBQUssRUFBRSxxQkFBcUI7UUFDNUIsUUFBUSxFQUFFLGVBQWU7UUFDekIsTUFBTSxFQUFFLEtBQUs7UUFDYixRQUFRLEVBQUUsSUFBSTtRQUNkLE9BQU8sRUFBRSxrQkFBa0I7UUFDM0IsS0FBSyxFQUFFLElBQUk7S0FDWjtJQUNELE1BQU0sRUFBRTtRQUNOLElBQUksRUFBRSxRQUFRO1FBQ2QsS0FBSyxFQUFFLHlCQUF5QjtRQUNoQyxRQUFRLEVBQUUsYUFBYTtRQUN2QixNQUFNLEVBQUUsS0FBSztRQUNiLElBQUksRUFBRTtZQUNKLFFBQVEsRUFBRSxLQUFLO1lBQ2YsWUFBWSxFQUFFLENBQUM7WUFDZixPQUFPLEVBQUUsdUJBQXVCO1lBQ2hDLEtBQUssRUFBRSxJQUFJO1lBQ1gsYUFBYSxFQUFFLElBQUksSUFBSSxFQUFFLENBQUMsT0FBTyxFQUFFO1lBQ25DLHVCQUF1QixFQUFFLElBQUk7WUFDN0IsbUJBQW1CLEVBQUUsSUFBSTtZQUN6QiwyQkFBMkIsRUFBRSx3QkFBd0I7WUFDckQsWUFBWSxFQUFFLENBQUM7WUFDZixRQUFRLEVBQUUsQ0FBQztZQUNYLGlCQUFpQixFQUFFLENBQUM7WUFDcEIsNkJBQTZCLEVBQUUsQ0FBQztZQUNoQyxTQUFTLEVBQUUsSUFBSTtZQUNmLFFBQVEsRUFBRSxJQUFJO1lBQ2Qsd0JBQXdCLEVBQUUsUUFBUTtZQUNsQyxrQ0FBa0MsRUFBRSxRQUFRO1lBQzVDLE9BQU8sRUFBRSxJQUFJO1lBQ2IsZUFBZSxFQUFFLENBQUM7WUFDbEIsY0FBYyxFQUFFLENBQUM7WUFDakIsaUJBQWlCLEVBQUUsQ0FBQztZQUNwQixxQkFBcUIsRUFBRSxDQUFDO1lBQ3hCLHFCQUFxQixFQUFFLEdBQUc7WUFDMUIsVUFBVSxFQUFFLENBQUM7WUFDYixNQUFNLEVBQUUsQ0FBQztZQUNULG1CQUFtQixFQUFFLENBQUM7WUFDdEIsd0JBQXdCLEVBQUUsQ0FBQztZQUMzQiwwQkFBMEIsRUFDeEIsa1pBQWtaO1lBQ3BaLGtCQUFrQixFQUFFLENBQUM7WUFDckIscUJBQXFCLEVBQUUsQ0FBQztZQUN4QixrQkFBa0IsRUFBRSxFQUFFO1lBQ3RCLFdBQVcsRUFBRSxZQUFZO1lBQ3pCLGFBQWEsRUFBRSxJQUFJO1lBQ25CLGdCQUFnQixFQUFFLENBQUM7WUFDbkIsdUJBQXVCLEVBQUUsQ0FBQztZQUMxQixTQUFTLEVBQUUsSUFBSTtTQUNoQjtLQUNGO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsSUFBSSxFQUFFLE9BQU87UUFDYixLQUFLLEVBQUUsNEJBQTRCO1FBQ25DLFFBQVEsRUFBRSxZQUFZO1FBQ3RCLE1BQU0sRUFBRSxLQUFLO1FBQ2IsUUFBUSxFQUFFLElBQUk7UUFDZCxPQUFPLEVBQUUsdUJBQXVCO1FBQ2hDLEtBQUssRUFBRSxJQUFJO0tBQ1o7Q0FDRixDQUFDO0FBRUYsa0JBQWUsS0FBSyxDQUFDIn0=